import * as React from "react";
import "../../../../utils/number_extensions";
import { useGlobalStores } from "../../../../hooks/use_global_stores";
import { ISnapshotV3 } from "../../../../config/snapshot";
import { Amount, Container, ItemContainer, OuterContainer, Title } from "./MoneyLeftLayoutComponents";

interface IMoneyLeftProps {
    snapshot: ISnapshotV3;
}

export const MoneyLeft = ({snapshot}: IMoneyLeftProps) => {
    const { currencyStore } = useGlobalStores();

    return (
        <OuterContainer>
            <Container>
                <ItemContainer>
                    <Amount variant="h2">
                        {(Math.round(snapshot.income_total) as any).toCurrency(currencyStore.currentCurrency, {minimumFractionDigits: 0})}
                    </Amount>
                    <Title variant="button">
                        Total monthly income
                    </Title>
                </ItemContainer>

                <ItemContainer>
                    <Amount variant="h2">
                        {(Math.round(snapshot.income_left) as any).toCurrency(currencyStore.currentCurrency, {minimumFractionDigits: 0})}
                    </Amount>
                    <Title variant="button">
                        Money left
                    </Title>
                </ItemContainer>

                <ItemContainer>
                    <Amount variant="h2">
                        {(Math.round(snapshot.monthly_recurring_expense) as any).toCurrency(currencyStore.currentCurrency, {minimumFractionDigits: 0})}
                    </Amount>
                    <Title variant="button">
                        Monthly recurring expenses
                    </Title>
                </ItemContainer>
            </Container>
        </OuterContainer>
    );
};
